// extracted by mini-css-extract-plugin
export default {"container":"dashboardForMeter_container__aeHAL"};